<template>
  <div class="sprites-setting" :style="{left: active ? 0 : '-100%'}">
    <div class="sprites-basic-setting">
      <div class="align-setting">
        <el-tooltip
          effect="dark"
          placement="bottom"
          v-for="item, i in alignData"
          :key="i"
          :content="item.name"
        >
          <div
            class="align-item"
            @click="spritesAlign(item.type, item.num, item.disable)"
            :class="{'disable': item.disable}"
          >
            <i :class="item.class" :style="{transform: `rotate(${item.rotate})`}"></i>
          </div>
        </el-tooltip>
      </div>
       <template v-if="!hasCrop && !hasClip">
            <div class="matting-setting" v-if="hasSwap" @click="swapClick">
              <i class="icon-set-swap"></i>
            <span>替换</span>
            </div>
       </template>
       <template v-else>
        <div class="setting-flex">
            <div class="swap-setting" v-if="hasSwap" @click="swapClick">
              <i class="icon-set-swap"></i>
              <span>替换</span>
            </div>
            <div class="crop-setting" v-if="hasCrop" @click="imgCrop">
              <i class="icon-set-crop"></i>
              <span>剪裁</span>
            </div>
            <div class="clip-setting" v-if="hasClip" @click="videoClip">
              <i class="icon-set-clip"></i>
              <span>剪辑</span>
            </div>
        </div>
      </template>
      <!-- 普通用户显示限免按钮 非企业用户显示抠图次数 -->
      <div class="matting-setting" v-if="hasCrop" @click="imgMatting">
        <div class="limit-free" v-if="isPoor">
          <span>限免</span>
        </div>
        <i class="icon-set-matting"></i>
        <span>一键抠图</span>
        <span v-if="!isEenterprise">{{`（${cutoutNum.use}/${cutoutNum.num}）`}}</span>
      </div>


      <div class="opacity-setting">
        <SliderSetting :list="opacity" @changeData="opacityChange" />
      </div>
      <div class="volume-setting" v-if="hasVolume">
        <SliderSetting :list="volume" @changeData="volumeChange" />
      </div>
      <div class="action-setting" v-if="hasAction">
        <el-popover
          v-model="isShowActionList"
          class="el-dropdown-action"
          popper-class="stroke-width-dropdown"
          placement="bottom"
          width="226"
          trigger="click"
        >
          <div class="el-dropdown-link" slot="reference">
            <span>{{actionList[actionIndex].title + ' - 动作'}}</span>
            <i
              class="icon-dropdown-arrow"
              :style="{transform: isShowActionList ? `rotate(180deg)` : ''}"
            ></i>
          </div>
          <div class="dropdown__options" :style="{width: '226px'}">
            <div
              class="dropdown__item"
              v-for="item, i in actionList"
              :key="i"
              :class="{active: i === actionIndex}"
              @click="actionChange(item, i)"
            >
              <span>{{item.title + ' - 动作'}}</span>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="loop-setting" v-if="hasLoop">
        <span>动效</span>
        <el-popover
          v-model="isShowLoopList"
          :class="{'loop-disable': isLoop}"
          :disabled="isLoop"
          class="el-dropdown-loop"
          popper-class="stroke-width-dropdown"
          placement="bottom"
          width="126"
          trigger="click"
        >
          <div class="el-dropdown-link" slot="reference">
            <span>{{loopCount+'次'}}</span>
            <i class="icon-set-down-l" :style="{transform: isShowLoopList ? `rotate(180deg)` : ''}"></i>
          </div>
          <div class="dropdown__options">
            <div
              class="dropdown__item"
              v-for="j in 11"
              :key="j"
              :class="{active: j - 1 === loopCount}"
              @click="loopChange(j - 1)"
            >
              <span>{{j - 1 +'次'}}</span>
            </div>
          </div>
        </el-popover>
        <el-tooltip effect="dark" content="动效循环" placement="top">
          <el-switch v-model="isLoop" @change="infiniteLoopChange"></el-switch>
        </el-tooltip>
      </div>
      <div class="fill-color-setting" v-if="hasShapeSvg">
        <span>填充色</span>
        <div
          class="setting-color"
          @click="showColorPicker($event, { whichPart: 'set-fill-color' });"
          :style="{backgroundColor: fillColor || '#fff'}"
        ></div>
      </div>
      <div class="stroke-setting" v-if="hasEditSvg">
        <span>线条</span>
        <div
          class="setting-color"
          @click="showColorPicker($event, { whichPart: 'set-stroke-color' });"
          :style="{backgroundColor: strokeColor || '#fff'}"
        ></div>
        <el-popover
          class="el-dropdown-stroke"
          popper-class="stroke-width-dropdown"
          placement="bottom"
          width="74"
          trigger="click"
        >
          <span class="el-dropdown-link" slot="reference">
            <span style="margin-left: 6px;">{{strokeWidth}}</span>
            <i class="icon-set-down-l"></i>
          </span>
          <div class="dropdown__options" :style="{width: '74px'}">
            <div
              class="dropdown__item"
              v-for="i in 11"
              :key="i"
              :class="{active: strokeWidth === i-1}"
              @click="setStrokeWidth(i-1)"
            >
              <span style="width: 20px">{{i-1}}</span>
              <span class="border-width-item" :style="{height: `${i-1}px`}"></span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <TextSetting
      v-if="hasText"
      :updateData="updateData"
      :hasVertical.sync="hasVertical"
      :hasArt.sync="hasArt"
      :hasStyle.sync="hasStyle"
    />
    <AppearSetting v-if="hasAppear" :updateData="updateData" />
    <ShadowSetting :textShadow="textShadow" :updateData="updateData" />
    <FilterSetting v-if="hasFilter" :filters="filters" @changeData="filterChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TextSetting from "./textSetting.vue";
import AppearSetting from "./appearSetting.vue";
import ShadowSetting from "./shadowSetting.vue";
import FilterSetting from "./filterSetting.vue";
import SliderSetting from "./sliderSetting.vue";
import getNavType from "@/components/mixins/getNavType";
import judgeMatting from '../mixins/judgeMatting';
export default {
  mixins: [getNavType, judgeMatting],
  props: {
    active: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data() {
    return {
      len: -1,
      sprites: [],
      hasSwap: false, // 是否可以替换
      hasLoop: false, // 是否有动效设置
      hasAction: false, // 是否有更换动作设置
      hasAppear: false, // 是否有外观设置
      textShadow: false, // 阴影是否区分文字
      hasFilter: false, // 是否有滤镜设置
      hasText: false, // 是否有文字设置
      hasVertical: false, // 是否有竖版文字
      hasArt: false, // 是否有艺术字
      hasStyle: false,
      hasCrop: false, // 是否有裁剪设置
      hasClip: false, // 是否有剪辑
      hasVolume: false, // 是否有音量设置
      hasShapeSvg: false,
      hasEditSvg: false,
      isShowActionList: false,
      isLoop: true,
      loopCount: 5,
      isShowLoopList: false,
      actionList: [{ title: "无" }],
      alignData: [
        {
          type: "left",
          name: "左对齐",
          num: 3,
          class: "icon-align-left",
          rotate: "0deg"
        },
        {
          type: "level-center",
          name: "水平居中",
          num: 5,
          class: "icon-align-center",
          rotate: "0deg"
        },
        {
          type: "right",
          name: "右对齐",
          num: 1,
          class: "icon-align-right",
          rotate: "0deg"
        },
        {
          type: "top",
          name: "顶对齐",
          num: 0,
          class: "icon-align-left",
          rotate: "90deg"
        },
        {
          type: "vertical-center",
          name: "垂直居中",
          num: 4,
          class: "icon-align-center",
          rotate: "90deg"
        },
        {
          type: "bottom",
          name: "底对齐",
          num: 2,
          class: "icon-align-right",
          rotate: "90deg"
        },
        {
          type: "level-equal",
          name: "水平等间距",
          num: 5,
          class: "icon-align-center-center",
          rotate: "0deg",
          disable: false
        },
        {
          type: "vertical-equal",
          name: "垂直等间距",
          num: 4,
          class: "icon-align-center-center",
          rotate: "90deg",
          disable: false
        }
      ],
      updateData: 0,
      filters: {},
      actionIndex: 0,
      actionId: "",
      opacity: [
        {
          name: "透明度",
          type: "opacity",
          step: 1,
          min: 0,
          max: 100,
          len: 100,
          val: 0,
          unit: "%"
        }
      ],
      volume: [
        {
          name: "音量",
          type: "volume",
          step: 1,
          min: 0,
          max: 100,
          len: 100,
          val: 0
        }
      ],
      fillColor: "#ffffff",
      strokeColor: "#ffffff",
      strokeWidth: 0,
      undoData: null
    };
  },
  computed: {
    ...mapGetters(["TOOL", "SelectScenes_Msg", "SelectSprites_Msg", "UserMsg", "isEenterprise", "isPoor"])
  },
  watch: {
    active: function() {
      this.initData();
    },
    SelectSprites_Msg: function() {
      this.initData();
    }
  },
  mounted() {
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
    this.$bus.on("colorPickerInput.picker", this.colorPickerInput);
    this.$bus.on("btn_panel", this._btn_panel);
    this.initData();
  },
  methods: {
    initData() {
      if (
        this.active &&
        this.SelectSprites_Msg &&
        this.SelectSprites_Msg.length >= 1
      ) {
        let s = this.SelectSprites_Msg[0];
        this.sprites = this.SelectSprites_Msg;
        this.len = this.sprites.length;
        if (this.len < 3) {
          this.alignData[6].disable = true;
          this.alignData[7].disable = true;
        } else {
          this.alignData[6].disable = false;
          this.alignData[7].disable = false;
        }

        this.hasAction = false;
        this.hasCrop = false;
        this.hasSwap = false;
        this.hasClip = false;
        if (this.len === 1) {
          if (s.type === "Lottie" || s.type === 'Gif' && s.option.fileType === 118) {
            if (this.getNavType() === "characters") {
              this.hasAction = true;
              this.actionId = s.option.resourceId;
              this.$http
                .get("/api/common/character/actions", {
                  params: {
                    id: this.actionId || localStorage.getItem("character-id")
                  }
                })
                .then(({ data: resData } = {}) => {
                  let { code, data } = resData;
                  if (data) {
                    this.actionList = [].concat(data);
                    this.actionIndex = data.findIndex(item => {
                      return item.id === this.actionId;
                    });
                  } else {
                    this.actionList = [{ title: "无" }];
                    this.actionIndex = 0;
                  }
                });
            }
          } else if (s.type === "Image") {
            let reg = /.svg$/g;
            this.hasCrop = true;
            if (reg.test(s.option.url)) {
              s.type = 'Svg';
              this.hasCrop = false;
            }

          } else if (s.type === "Video") {
            this.hasClip = true;
          }
          if (s.type !== "Text" && s.type !== "Chart" && s.type !== "RichText")
            this.hasSwap = true;
        }

        this.hasLoop = true;
        this.hasVertical = false;
        this.hasArt = false;
        this.hasStyle = false;
        this.hasVolume = true;
        this.hasShapeSvg = true;
        this.hasEditSvg = true;
        let ts = new Set();
        for (let i = 0; i < this.len; i++) {
          let t = this.sprites[i].type;
          ts.add(t);
          if (t !== "Gif" && t !== "Lottie" && t !== "Video") {
            this.hasLoop = false;
          }
          if (t === "Text") {
            if (this.sprites[i].versionAnyway === "Vertical")
              this.hasVertical = true;
            if (this.sprites[i].artType) this.hasArt = true;
            if (
              this.sprites[i].font.textDecoration !== "none" ||
              this.sprites[i].font.fontStyle === "italic"
            ) {
              this.hasStyle = true;
            }
          }

          if (t !== "Video" && !this.sprites[i].sound) {
            this.hasVolume = false;
          }

          if (t === 'Video') {
            const s = this.sprites[i];
            if (s.video && !s.video.hasAudio) {
              this.hasVolume = false;
            }
          }

          if (
            this.hasShapeSvg &&
            !this.$isEditableShape(this.sprites[i].option.fileType)
          ) {
            this.hasShapeSvg = false;
          }
          if (
            this.hasEditSvg &&
            !this.$isEditableSvg(this.sprites[i].option.fileType)
          ) {
            this.hasEditSvg = false;
          }
        }

        if (this.hasVolume) {
          if (s.type === "Video") {
            this.volume[0].val = s.video.volume;
          } else {
            this.volume[0].val = s.sound.volume;
          }
        }

        if (this.hasLoop) {
          let loop = this.sprites[0].getLoop();
          this.isLoop = loop.isLoop;
          this.loopCount = loop.numberOfLoops;
        }

        if (this.hasShapeSvg) {
          this.fillColor = s.option.fill || s.fill || "#ffffff";
        }

        if (this.hasEditSvg) {
          this.strokeColor = s.option.stroke || s.stroke || "#ffffff";
          this.strokeWidth = s.option.strokeWidth || 0;
        }

        this.hasText = false;
        if (ts.size === 1 && ts.has("Text")) {
          this.hasText = true;
        }

        if (ts.has("Text")) {
          this.hasAppear = false;
          this.textShadow = true;
          this.hasFilter = false;
        } else {
          this.hasAppear = true;
          this.textShadow = false;
          this.hasFilter = true;
          this.filters = Object.assign({}, s.filter);
        }

        this.opacity[0].val = this.opacityT(s.opacity, true);

        this.updateData++;
      }
    },
    spritesAlign(type, num, bol) {
      if (bol) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        scale: this.TOOL.scale,
        val: [],
        oldVal: []
      };
      let boxData = [];
      if (this.len === 1) {
        this.sprites[0].action = "move";
        boxData = [
          0,
          this.TOOL.clientWidth,
          this.TOOL.clientHeight,
          0,
          this.TOOL.clientHeight / 2,
          this.TOOL.clientWidth / 2
        ];
      } else {
        let css = this.TOOL.multiSelect.css;
        boxData = [
          css.top,
          css.left + css.width,
          css.top + css.height,
          css.left,
          css.top + css.height / 2,
          css.left + css.width / 2
        ];
        this.TOOL.multiSelect.action = false;
      }

      let boxs = null;
      if (type === "level-equal" || type === "vertical-equal") {
        boxs = [];
        for (let i = 0; i < this.len; i++) {
          boxs.push({
            index: i,
            box: this.sprites[i]._getAdsorbData(),
            nb: 0
          });
        }
        boxs.sort((a, b) => {
          return a.box[num] - b.box[num];
        });
        let ab = boxs[this.len - 1].box[num] - boxs[0].box[num];
        let av = ab / (this.len - 1);

        for (let j = 1; j < this.len - 1; j++) {
          boxs[j].nb = boxs[0].box[num] + av * j - boxs[j].box[num];
        }

        boxs.sort((a, b) => {
          return a.index - b.index;
        });
      }

      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];
        let o = {
          id: s.id,
          width: s.width,
          height: s.height,
          positionLeft: s.positionLeft,
          positionTop: s.positionTop,
          rotate: s.rotate
        };
        let oo = Object.assign({}, o);
        let sbox = s._getAdsorbData();
        if (!boxs) {
          if (num % 2) {
            oo.positionLeft = o.positionLeft - sbox[num] + boxData[num];
          } else {
            oo.positionTop = o.positionTop - sbox[num] + boxData[num];
          }
        } else {
          if (boxs[i].nb) {
            if (num % 2) {
              oo.positionLeft = o.positionLeft + boxs[i].nb;
            } else {
              oo.positionTop = o.positionTop + boxs[i].nb;
            }
          }
        }

        s.positionLeft = oo.positionLeft;
        s.positionTop = oo.positionTop;
        s.changeStyle();
        undoData.val.push(oo);
        undoData.oldVal.push(o);
      }

      if (this.len === 1) {
        this.sprites[0].action = "";
      } else {
        this.TOOL.multiSelect.action = false;
        this.TOOL.calcMultiSelect("rePaint");
      }
      this.$bus.emit("calcSpriteBtn");
      eve("undo_redo", null, { type: "matrix", data: undoData });
    },
    filterChange(val, status, type) {
      let bol = false,
        data = {};
      data[type] = val;
      if (status === "start") {
        this._getUndoData();
        for (let i = 0; i < this.len; i++) {
          let s = this.sprites[i];
          let o = {};
          o[type] = s.filter[type];
          this.undoData.reData.push({
            id: s.id,
            filter: o
          });
        }
        return;
      } else if (status === "end") {
        bol = true;
        this.undoData.data = Object.assign({}, data);
      }
      for (let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        s.setFilter(data);
      }

      if (bol) {
        eve("undo_redo", null, { type: "setFilters", data: this.undoData });
        this.undoData = null;
      }
    },
    infiniteLoopChange(bool) {
      this._getUndoData();
      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];
        let loop = s.getLoop();
        this.undoData.reData.push({
          id: s.id,
          val: loop.isLoop ? true : loop.numberOfLoops
        });
        this.undoData.data.push({
          id: s.id,
          val: bool
        });
        s.setLoop(bool);
      }
      eve("undo_redo", null, { type: "setLoops", data: this.undoData });
      this.undoData = null;
    },
    loopChange(val) {
      this.isShowLoopList = false;
      this._getUndoData();
      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];
        let loop = s.getLoop();

        this.undoData.reData.push({
          id: s.id,
          val: loop.isLoop ? true : loop.numberOfLoops
        });
        this.undoData.data.push({
          id: s.id,
          val: val
        });

        if (s.type === "Video") {
          s.setRepeatTimes(val);
        } else {
          s.setLoop(val);
        }
      }

      this.loopCount = val;
      eve("undo_redo", null, { type: "setLoops", data: this.undoData });
      this.undoData = null;
    },
    actionChange(item, i) {
      if (i === this.actionIndex) return;
      let s = this.sprites[0];
      this.actionIndex = i;
      let spriteOptions = {
        sprite: s,
        typeForAdd: "Lottie",
        optionForAdd: {
          lottieOptions: {
            path: item.url,
            loop: 4,
            autoplay: true
          },
          resourceId: item.id,
          actionId: item.id,
          fileType: item.fileType
        },
        options: {
          type: "motion"
        }
      };
      if (s.type === 'Gif') {
        spriteOptions = {
          sprite: s,
          typeForAdd: 'Gif',
          optionForAdd: {
            url: item.url,
            resourceId: item.id, // 资源id
            fileType: item.fileType, // 资源type
            isLoop:
              typeof s.isLoop === "boolean"
                ? s.isLoop
                : s.option.isLoop,
            numberOfLoops: s.numberOfLoops,
          }
        }
      }
      this.TOOL.swapSprite(
        spriteOptions,
        true
      );
    },
    async imgMatting () {
      // Image素材抠图
      if(!this.judgeMatting()) {
        // 抠图剩余次数为0
        return;
      }
      let anim = $('.set-pathAnim');
      if (anim && (parseInt(anim.css('opacity')) === '0' || anim.css('display') === 'none')) {
        let s = Object.assign(this.sprites[0]);
        let url = s.option.url;
        let tSprite = {};
        tSprite = Object.assign(tSprite, s);
        tSprite.mattingPicture = s.mattingPicture;
        tSprite.finishApiMatting = s.finishApiMatting;
        this.$bus.emit('setting_matting');
        tSprite.mattingPicture();
        let res = await this.$http.post(`/api/common/cutout?key=${url}`); // &type=2&faceAnalysis=1
        if (!res.data || res.data.code !== 200) {
          return;
        }
        let result = res.data.data;
        tSprite.finishApiMatting({
          data: result.url
        });
        sensors.track('doratoonMatting', {
        });
        const {num, use} = result;
        this.$store.commit('toggle_UserMsgCutout', {num, use});
        return;
      }
      // 路径动画抠图
      this.$bus.emit('set-pathAnim-matting');
    },
    videoClip() {
      this.$modal.show("videoSprite.cutting", { sprite: this.sprites[0] });
    },
    imgCrop() {
      let s = this.sprites[0];
      if (s.cropType !== "svg") {
        this.$bus.emit("cropfreelayer");
      } else {
        this.$bus.emit("cropsvglayer");
      }
      this.$bus.emit("FeaturesPop_vue", {
        name: "cropping",
        type: 1,
        sprite: s
      });
    },
    opacityChange(val, status) {
      let bol = false;
      let opa = this.opacityT(val);
      if (status === "start") {
        this._getUndoData();
        for (let i = 0; i < this.len; i++) {
          let s = this.sprites[i];
          this.undoData.reData.push({
            id: s.id,
            opacity: s.opacity
          });
        }
        return;
      } else if (status === "end") {
        bol = true;
      }
      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];
        s._opacity = null;
        s.opacity = opa;
        if (bol) {
          this.undoData.data.push({
            id: s.id,
            opacity: opa
          });
        }
        s.changeStyle({ sync: bol });
      }
      if (bol) {
        eve("undo_redo", null, { type: "opacitys", data: this.undoData });
        this.undoData = null;
      }
    },
    opacityT(val, bol) {
      if (bol) {
        return Math.round((1 - val) * 100);
      } else {
        return +(1 - val / 100).toFixed(2);
      }
    },
    volumeChange(val, status) {
      let bol = false;
      if (status === "start") {
        this._getUndoData();
        for (let i = 0; i < this.len; i++) {
          let s = this.sprites[i];
          this.undoData.reData.push({
            id: s.id,
            volume: s.type === "Video" ? s.video.volume : s.sound.volume
          });
        }
        return;
      } else if (status === "end") {
        bol = true;
        this.$bus.emit('panel_btn', {type: 'volume'})
      }

      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];

        if (bol) {
          this.undoData.data.push({
            id: s.id,
            volume: val
          });
        }

        if (s.type === "Video") {
          s.setVolume(val);
        } else {
          s.setSound({
            volume: val
          });
        }
      }

      if (bol) {
        eve("undo_redo", null, { type: "volumes", data: this.undoData });
        this.undoData = null;
      }
    },
    swapClick() {
      const runner = () => {
        let longType = this.getNavType();
        let typeArr = longType.split(".");
        // 打开 rightNav
        this.$bus.emit("materialPane_vue", {
          type: typeArr[0],
          name: typeArr[1],
          judge: !!typeArr[1]
        });
        this.$store.commit("save_SpriteOperation", "swap");
        // 弹出气泡提示
        this.$bus.emit("blackPopupMsg_showTips", {
          text: "选择左边的素材可进行替换",
          position: {
            top: "186px",
            left: "396px"
          }
        });
      };
      if (this.MaterialNavReady) {
        runner();
      } else {
        this.$bus.emit("materialPane_vue", { type: "props" });
        setTimeout(runner, 500);
      }
    },
    setStrokeWidth(val) {
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        scale: this.TOOL.scale,
        data: val,
        reData: []
      };
      this.strokeWidth = val;
      for (let i = 0; i < this.len; i++) {
        let s = this.sprites[i];
        undoData.reData.push({
          id: s.id,
          val: s.option.strokeWidth
        });
        s.updateSprite({ strokeWidth: val });
      }
      this.$bus.emit("panel_btn", { type: "strokeWidth", val: val });
      eve("undo_redo", null, { type: "strokeWidths", data: undoData });
    },
    showColorPicker(e, { whichPart } = {}) {
      let rect = e.target.getBoundingClientRect();
      this.$bus.emit("FeaturesPop_vue", {
        name: "color",
        type: 1,
        posx: rect.left - 150,
        posy: rect.top + 40,
        whichPart,
        color: this.fontColor
      });
    },
    colorPickerInput(obj, { type }) {
      if (!obj.hex) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        scale: this.TOOL.scale,
        data: obj.hex,
        reData: []
      };
      if (type === "set-stroke-color") {
        this.strokeColor = obj.hex;
        for (let i = 0; i < this.len; i++) {
          let s = this.sprites[i];
          undoData.reData.push({
            id: s.id,
            val: s.option.stroke || s.stroke
          });
          s.updateSprite({ stroke: obj.hex });
        }
        this.$bus.emit("panel_btn", { type: "strokeColor", val: obj.hex });
        eve("undo_redo", null, { type: "strokeColors", data: undoData });
      } else if (type === "set-fill-color") {
        this.fillColor = obj.hex;
        for (let i = 0; i < this.len; i++) {
          let s = this.sprites[i];
          undoData.reData.push({
            id: s.id,
            val: s.option.fill || s.fill
          });
          s.updateSprite({ fill: obj.hex });
        }
        this.$bus.emit("panel_btn", { type: "fillColor", val: obj.hex });
        eve("undo_redo", null, { type: "fillColors", data: undoData });
      }
    },
    _btn_panel(data) {
      if (data.type === "strokeWidth") {
        this.strokeWidth = data.data;
      } else if (data.type === "strokeColor") {
        this.strokeColor = data.data;
      } else if (data.type === "fillColor") {
        this.fillColor = data.data;
      } else if (data.type === "volume") {
        this.initData();
      }
    },
    _getUndoData() {
      this.undoData = {
        scenesId: this.SelectScenes_Msg.id,
        scale: this.TOOL.scale,
        data: [],
        reData: []
      };
    },
    _undoRedoHandle({ type }) {
      if (
        type === "opacitys" ||
        type === "volumes" ||
        type === "setLoops" ||
        type === "setFilters"
      ) {
        this.initData();
      } else if (
        type === "strokeWidths" ||
        type === "strokeColors" ||
        type === "fillColors"
      ) {
        // 异步问题导致数据更新会慢一步
        setTimeout(() => {
          this.initData();
        });
      }
    }
  },
  beforeDestroy() {
    this.$bus.off("undoRedoHandle", this._undoRedoHandle);
    this.$bus.off("colorPickerInput.picker", this.colorPickerInput);
    this.$bus.off("btn_panel", this._btn_panel);
  },
  components: {
    TextSetting,
    AppearSetting,
    ShadowSetting,
    FilterSetting,
    SliderSetting
  }
};
</script>

<style lang="scss" scoped>
.sprites-setting {
  position: absolute;
  top: 0;
  left: 0;
  width: 226px;
  color: #737596;
  transition: all 0.3s;
}

.sprites-basic-setting {
  border-bottom: 1px solid #d9ddea;
}

.setting-flex,
.align-setting,
.loop-setting,
.matting-setting,
.opacity-setting,
.volume-setting,
.fill-color-setting,
.stroke-setting {
  margin: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.align-setting {
  border: 1px solid #d9ddea;
  border-radius: 4px;
  padding: 8px;
  margin-top: 10px;

  .align-item {
    width: 16px;
    height: 16px;
    cursor: pointer;

    i {
      display: block;
      width: 16px;
      height: 16px;
    }

    &:hover {
      .icon-align-center {
        background: url("../../../static/svg/align-center-active.svg") no-repeat
          center;
      }
      .icon-align-right {
        background: url("../../../static/svg/align-right-active.svg") no-repeat
          center;
      }
      .icon-align-left {
        background: url("../../../static/svg/align-left-active.svg") no-repeat
          center;
      }
      .icon-align-center-center {
        background: url("../../../static/svg/align-center-center.svg") no-repeat
          center;
        background-size: 89%;
      }
    }
  }

  .align-item.disable {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .icon-align-left {
    background: url("../../../static/svg/align-left.svg") no-repeat center;
  }
  .icon-align-right {
    background: url("../../../static/svg/align-right.svg") no-repeat center;
  }
  .icon-align-center {
    background: url("../../../static/svg/align-center.svg") no-repeat center;
  }
  .icon-align-center-center {
    background: url("../../../static/svg/align-center-center-active.svg")
      no-repeat center;
    background-size: 89%;
  }
}
.swap-setting,.crop-setting,.clip-setting{
  width: 108px;
}
.swap-setting,
.matting-setting,
.crop-setting,
.clip-setting,
.tailor-setting {
  display: flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  cursor: pointer;

  i {
    margin-right: 8px;
  }

  &:hover {
    border-color: #5778fb;
  }
}
.matting-setting {
  position: relative;
}
.limit-free {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 36px;
  height: 15px;
  background: linear-gradient(126deg, #36332F 0%, #12100A 100%);
  border-radius: 1px 3px 1px 8px;
  line-height: 16px;
  span {
    display: block;
    color: #f8dbb2;
    transform: scale(0.625);
    font-size: 16px;
    font-weight: 500;
  }
}
.fill-color-setting,
.stroke-setting {
  justify-content: start;

  > span {
    width: 50px;
    text-align: left;
  }

  div.setting-color {
    width: 36px;
    height: 24px;
    border-radius: 4px;
    background-color: #5779fa;
    cursor: pointer;
    border: 1px solid #d9dde9;
  }

  .el-dropdown-stroke {
    margin-left: 10px;
  }
}
.stroke-setting .el-dropdown-stroke {
  width: 74px;
  height: 24px;
  line-height: 24px;
  border: solid 1px #d9dde9;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}
.el-dropdown-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}
.el-dropdown-action,
.el-dropdown-loop {
  width: 226px;
  height: 32px;
  line-height: 32px;
  border: solid 1px #d9ddea;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  padding-left: 12px;
  padding-right: 12px;
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;

  .el-dropdown-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
  }
}
.el-dropdown-loop {
  width: 126px;
  height: 25px;
  line-height: 25px;

  &.loop-disable {
    opacity: .5;
    cursor: not-allowed;
  }

  .el-dropdown-link {
    height: 25px;
  }
}
.icon-dropdown-arrow {
  transition-duration: 0.2s;
}
.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 126px;
    height: 24px;
    line-height: 24px;
    border: solid 1px #d9dde9;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 126px;
    border: solid 1px #d9dde9;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;
    padding: 0 3px;

    & > span:nth-child(1) {
      text-align: center;
      color: #9692a9;
    }
    &:hover,
    &.active {
      background-color: #d9dde9;
    }
  }
}
.border-width-item {
  width: 40px;
  background-color: #9692a9;
}
</style>



// WEBPACK FOOTER //
// src/components/settingPanel/spritesSetting.vue